/* WorkplaceTechHub procurement list.
   Saves products in this browser only. No account, no server call, no cookies.
   Every localStorage access is wrapped: the pages work without it. */
(function () {
  'use strict';

  var KEY = 'wth_procurement_list_v1';

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list));
      return true;
    } catch (e) {
      return false;
    }
  }

  function findByHandle(handle) {
    var list = read();
    for (var i = 0; i < list.length; i++) {
      if (list[i].handle === handle) return list[i];
    }
    return null;
  }

  function count() {
    return read().length;
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function paintCounts() {
    var n = count();
    var nodes = document.querySelectorAll('[data-b2b-list-count]');
    for (var i = 0; i < nodes.length; i++) nodes[i].textContent = String(n);
  }

  function paintButtons() {
    var buttons = document.querySelectorAll('[data-b2b-save]');
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var label = btn.querySelector('[data-b2b-save-label]');
      var saved = !!findByHandle(btn.getAttribute('data-handle'));
      if (label) label.textContent = saved ? 'Saved, view list' : 'Save to procurement list';
      btn.setAttribute('data-b2b-saved', saved ? 'true' : 'false');
    }
  }

  function saveItem(btn) {
    var handle = btn.getAttribute('data-handle');
    if (!handle) return;
    if (findByHandle(handle)) {
      window.location.href = '/pages/procurement-list';
      return;
    }
    var item = {
      handle: handle,
      title: btn.getAttribute('data-title') || '',
      sku: btn.getAttribute('data-sku') || '',
      price: btn.getAttribute('data-price') || '',
      image: btn.getAttribute('data-image') || '',
      savedAt: new Date().toISOString()
    };
    var list = read();
    list.push(item);
    var ok = write(list);
    paintButtons();
    paintCounts();
    var note = btn.parentNode ? btn.parentNode.querySelector('[data-b2b-save-error]') : null;
    if (!ok) {
      if (!note) {
        note = document.createElement('p');
        note.setAttribute('data-b2b-save-error', '');
        note.className = 'b2b-cta-meta';
        note.textContent = 'This browser blocked local storage, so the list could not be saved.';
        if (btn.parentNode) btn.parentNode.appendChild(note);
      }
    } else if (note) {
      note.remove();
    }
  }

  function itemText(item) {
    return '- ' + item.title + (item.sku ? ' (SKU ' + item.sku + ')' : '') + (item.price ? ', ' + item.price : '');
  }

  function renderList() {
    var root = document.querySelector('[data-b2b-list]');
    if (!root) return;
    var list = read();
    var empty = document.querySelector('[data-b2b-list-empty]');
    var table = document.querySelector('[data-b2b-list-items]');
    var quoteBtn = document.querySelector('[data-b2b-list-quote]');
    var copyBox = document.querySelector('[data-b2b-list-text]');

    if (empty) empty.hidden = list.length > 0;
    if (quoteBtn) quoteBtn.hidden = list.length === 0;
    if (table) table.hidden = list.length === 0;
    if (!table) return;

    var html = '';
    for (var i = 0; i < list.length; i++) {
      var it = list[i];
      html += '<div class="b2b-list-row">';
      if (it.image) {
        html += '<a class="b2b-list-thumb" href="/products/' + encodeURIComponent(it.handle) + '">' +
          '<img src="' + escapeHtml(it.image) + '" alt="" loading="lazy"></a>';
      }
      html += '<div class="b2b-list-main"><a href="/products/' + encodeURIComponent(it.handle) + '">' +
        escapeHtml(it.title) + '</a>';
      if (it.sku) html += '<div class="b2b-list-sku">SKU ' + escapeHtml(it.sku) + '</div>';
      html += '</div>';
      if (it.price) html += '<div class="b2b-list-price">' + escapeHtml(it.price) + '</div>';
      html += '<button type="button" class="b2b-list-remove" data-b2b-remove="' + escapeHtml(it.handle) + '">Remove</button>';
      html += '</div>';
    }
    table.innerHTML = html;

    if (copyBox) {
      var text = list.map(itemText).join('\n');
      copyBox.value = text;
    }

    var buttons = table.querySelectorAll('[data-b2b-remove]');
    for (var j = 0; j < buttons.length; j++) {
      buttons[j].addEventListener('click', function () {
        var h = this.getAttribute('data-b2b-remove');
        var next = read().filter(function (x) { return x.handle !== h; });
        write(next);
        renderList();
        paintButtons();
        paintCounts();
      });
    }
  }

  function prefillForms() {
    var params = new URLSearchParams(window.location.search);
    var title = params.get('product_title');
    var sku = params.get('sku');
    var productField = document.querySelector('#qf-product');
    if (productField && (title || sku)) {
      var val = title || '';
      if (sku) val += (val ? ' (SKU: ' : 'SKU: ') + sku + (val ? ')' : '');
      productField.value = val;
    }
    var hiddenProduct = document.querySelector('input[name="contact[product]"]');
    if (hiddenProduct && !hiddenProduct.value && (title || sku)) {
      hiddenProduct.value = (title || '') + (sku ? ' (SKU: ' + sku + ')' : '');
    }
    if (params.get('list') === '1') {
      var message = document.querySelector('#qf-message');
      var list = read();
      if (message && list.length && !message.value) {
        message.value = 'Quote request for my saved procurement list:\n' + list.map(itemText).join('\n');
      }
    }
  }

  function copyList() {
    var btn = document.querySelector('[data-b2b-list-copy]');
    var box = document.querySelector('[data-b2b-list-text]');
    if (!btn || !box) return;
    btn.addEventListener('click', function () {
      box.select();
      var done = false;
      try { done = document.execCommand('copy'); } catch (e) { done = false; }
      if (!done && navigator.clipboard) {
        navigator.clipboard.writeText(box.value).then(function () {
          btn.textContent = 'Copied';
        });
      } else {
        btn.textContent = done ? 'Copied' : 'Select and copy the text above';
      }
    });
  }

  function init() {
    var buttons = document.querySelectorAll('[data-b2b-save]');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener('click', function (e) {
        e.preventDefault();
        saveItem(this);
      });
    }
    paintButtons();
    paintCounts();
    renderList();
    prefillForms();
    copyList();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
